import { Schema } from '../../../utils/form';
import { FormattedMessage } from 'react-intl';

export default Schema.object({
  allowEdit: Schema.string(),
  id: Schema.string(),
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  idIntegracao: Schema.string().label(<FormattedMessage id="idIntegracao" />),
  cargo: Schema.string().label(<FormattedMessage id="cargo" />),
  descricao: Schema.string().label(<FormattedMessage id="descricao" />),
  tags: Schema.string().label(''),
  vinculo: Schema.string().label(<FormattedMessage id="vinculo" />),
  areasSubordinadas: Schema.string().label(''),
  tipoFiltroData: Schema.string().label( <FormattedMessage id="label.tipoFiltroData" />),
  dataInicio: Schema.string().label(''),
  dataTermino: Schema.string().label(''),
  areaVinculo: Schema.string(),
  colaborador: Schema.string()
});
